var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticClass: "text-center",
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading
            ? _c(
                "div",
                [
                  _vm.records.length
                    ? [
                        _c("Chart", {
                          attrs: { options: _vm.chartOptionsDelayed },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  [
                    _c("h5", { staticClass: "text-center" }, [
                      _vm._v("Без пауз!"),
                    ]),
                  ],
                ],
                2
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Мои паузы в смене")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }